// @generated by protobuf-ts 2.11.1
// @generated from protobuf file "currency.proto" (package "currency", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { CurrencyService } from "./currency";
import type { DeleteCurrencyResponse } from "./currency";
import type { DeleteCurrencyRequest } from "./currency";
import type { SetDefaultCurrencyResponse } from "./currency";
import type { SetDefaultCurrencyRequest } from "./currency";
import type { UpdateCurrencyResponse } from "./currency";
import type { UpdateCurrencyRequest } from "./currency";
import type { CreateCurrencyResponse } from "./currency";
import type { CreateCurrencyRequest } from "./currency";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetAllCurrenciesResponse } from "./currency";
import type { GetAllCurrenciesRequest } from "./currency";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service currency.CurrencyService
 */
export interface ICurrencyServiceClient {
    /**
     * @generated from protobuf rpc: GetAllCurrencies
     */
    getAllCurrencies(input: GetAllCurrenciesRequest, options?: RpcOptions): UnaryCall<GetAllCurrenciesRequest, GetAllCurrenciesResponse>;
    /**
     * @generated from protobuf rpc: CreateCurrency
     */
    createCurrency(input: CreateCurrencyRequest, options?: RpcOptions): UnaryCall<CreateCurrencyRequest, CreateCurrencyResponse>;
    /**
     * @generated from protobuf rpc: UpdateCurrency
     */
    updateCurrency(input: UpdateCurrencyRequest, options?: RpcOptions): UnaryCall<UpdateCurrencyRequest, UpdateCurrencyResponse>;
    /**
     * @generated from protobuf rpc: SetDefaultCurrency
     */
    setDefaultCurrency(input: SetDefaultCurrencyRequest, options?: RpcOptions): UnaryCall<SetDefaultCurrencyRequest, SetDefaultCurrencyResponse>;
    /**
     * @generated from protobuf rpc: DeleteCurrency
     */
    deleteCurrency(input: DeleteCurrencyRequest, options?: RpcOptions): UnaryCall<DeleteCurrencyRequest, DeleteCurrencyResponse>;
}
/**
 * @generated from protobuf service currency.CurrencyService
 */
export class CurrencyServiceClient implements ICurrencyServiceClient, ServiceInfo {
    typeName = CurrencyService.typeName;
    methods = CurrencyService.methods;
    options = CurrencyService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetAllCurrencies
     */
    getAllCurrencies(input: GetAllCurrenciesRequest, options?: RpcOptions): UnaryCall<GetAllCurrenciesRequest, GetAllCurrenciesResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAllCurrenciesRequest, GetAllCurrenciesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateCurrency
     */
    createCurrency(input: CreateCurrencyRequest, options?: RpcOptions): UnaryCall<CreateCurrencyRequest, CreateCurrencyResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateCurrencyRequest, CreateCurrencyResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCurrency
     */
    updateCurrency(input: UpdateCurrencyRequest, options?: RpcOptions): UnaryCall<UpdateCurrencyRequest, UpdateCurrencyResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCurrencyRequest, UpdateCurrencyResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetDefaultCurrency
     */
    setDefaultCurrency(input: SetDefaultCurrencyRequest, options?: RpcOptions): UnaryCall<SetDefaultCurrencyRequest, SetDefaultCurrencyResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetDefaultCurrencyRequest, SetDefaultCurrencyResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteCurrency
     */
    deleteCurrency(input: DeleteCurrencyRequest, options?: RpcOptions): UnaryCall<DeleteCurrencyRequest, DeleteCurrencyResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteCurrencyRequest, DeleteCurrencyResponse>("unary", this._transport, method, opt, input);
    }
}
